import React from "react";
import { Button, Grid, Loading } from "@sumprio/ui";

export interface SideModalFormFooterProps {
  onCancel: () => void;
  cancelLabel?: string;
  cancelDisabled?: boolean;
  onMiddle: () => void;
  middleLabel?: string;
  middleDisabled?: boolean;
  onPrimary: () => void;
  primaryLabel: string;
  primaryDisabled?: boolean;
  primaryLoading?: boolean;
  primaryLoadingLabel?: string;
  primaryVariant?: React.ComponentProps<typeof Button>["variant"];
  primaryType?: React.ComponentProps<typeof Button>["type"];
}

export default function SideModalFormFooter({
  onCancel,
  cancelLabel = "Cancel",
  cancelDisabled = false,
  onMiddle,
  middleLabel = "Clear",
  middleDisabled = false,
  onPrimary,
  primaryLabel,
  primaryDisabled = false,
  primaryLoading = false,
  primaryLoadingLabel,
  primaryVariant = "brand-default",
  primaryType = "brand",
}: SideModalFormFooterProps) {
  return (
    <Grid
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      flexWrap="nowrap"
      gap="md"
    >
      <Button
        variant="brand-tertiaryColor"
        size="xs"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onMiddle();
        }}
        disabled={middleDisabled}
      >
        {middleLabel}
      </Button>
      <Grid display="flex" alignItems="center" gap="sm" flexShrink={0} flexWrap="nowrap">
        <Button
          variant="brand-secondaryGrey"
          size="xs"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onCancel();
          }}
          disabled={cancelDisabled}
        >
          {cancelLabel}
        </Button>
        <Button
          type={primaryType}
          variant={primaryVariant}
          size="xs"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onPrimary();
          }}
          disabled={primaryDisabled || primaryLoading}
        >
          {primaryLoading ? (
            <Grid display="flex" alignItems="center" justifyContent="center" gap="xs">
              <Loading variant="lineSpinner" size="sm" />
              {primaryLoadingLabel ?? primaryLabel}
            </Grid>
          ) : (
            primaryLabel
          )}
        </Button>
      </Grid>
    </Grid>
  );
}
